import {
  ASIN_LIST,
  ASIN_OPEN,
  ASIN_VIEW_DETAILS,
  GET_MORE_ASIN_LIST,
  PLAY_GROUND_CREATE,
} from "./Asin.action";

const intailreducer = {
  asinList: [],
  // asinDetails: {},
  asinDetails: false,
  playgroundData: false,
};

export const asinReducer = (state = intailreducer, action) => {
  switch (action.type) {
    case ASIN_LIST:
      return { ...state, asinList: action.value };
    case GET_MORE_ASIN_LIST:
      return { ...state, asinList: [...state.asinList, ...action.value] };
    case ASIN_OPEN:
      return { ...state, asinBar: action.value };
    case ASIN_VIEW_DETAILS:
      return { ...state, asinDetails: action.value };
    case PLAY_GROUND_CREATE:
      return { ...state, playgroundData: action.value };
    default:
      return state;
  }
};
